'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var valuesOf = {};

exports.__exports = valuesOf;
